import { IconProps } from './types';

const OpenInNewTabIcon = (props: IconProps) => {
  const { width = '14', height = '14', fillColor = 'var(--blue-base)' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
        <rect width="14" height="14" fill="var(--lightgray-base)" />
      </mask>
      <g mask="url(#mask0_13464_52039)">
        <path
          d="M2.91667 12.25C2.59583 12.25 2.32108 12.1359 2.09242 11.9076C1.86414 11.6789 1.75 11.4042 1.75 11.0833V2.91667C1.75 2.59583 1.86414 2.32108 2.09242 2.09242C2.32108 1.86414 2.59583 1.75 2.91667 1.75H6.41667C6.58194 1.75 6.72058 1.80581 6.83258 1.91742C6.94419 2.02942 7 2.16806 7 2.33333C7 2.49861 6.94419 2.63706 6.83258 2.74867C6.72058 2.86067 6.58194 2.91667 6.41667 2.91667H2.91667V11.0833H11.0833V7.58333C11.0833 7.41806 11.1393 7.27942 11.2513 7.16742C11.3629 7.05581 11.5014 7 11.6667 7C11.8319 7 11.9704 7.05581 12.082 7.16742C12.194 7.27942 12.25 7.41806 12.25 7.58333V11.0833C12.25 11.4042 12.1359 11.6789 11.9076 11.9076C11.6789 12.1359 11.4042 12.25 11.0833 12.25H2.91667ZM5.25 8.75C5.14306 8.64306 5.08958 8.50694 5.08958 8.34167C5.08958 8.17639 5.14306 8.04028 5.25 7.93333L10.2667 2.91667H8.75C8.58472 2.91667 8.44628 2.86067 8.33467 2.74867C8.22267 2.63706 8.16667 2.49861 8.16667 2.33333C8.16667 2.16806 8.22267 2.02942 8.33467 1.91742C8.44628 1.80581 8.58472 1.75 8.75 1.75H11.6667C11.8319 1.75 11.9704 1.80581 12.082 1.91742C12.194 2.02942 12.25 2.16806 12.25 2.33333V5.25C12.25 5.41528 12.194 5.55372 12.082 5.66533C11.9704 5.77733 11.8319 5.83333 11.6667 5.83333C11.5014 5.83333 11.3629 5.77733 11.2513 5.66533C11.1393 5.55372 11.0833 5.41528 11.0833 5.25V3.73333L6.05208 8.76458C5.94514 8.87153 5.81389 8.925 5.65833 8.925C5.50278 8.925 5.36667 8.86667 5.25 8.75Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default OpenInNewTabIcon;
